import { api } from "@/lib/api";

export const fetchPublicAppPages = async () => {
  const res = await api.get("/app-pages");
  return res.data;
};

export const fetchPublicAppPage = async (slug) => {
  const res = await api.get(`/app-pages/slug/${slug}`);
  return res.data;
};

export const fetchAdminAppPages = async () => {
  const res = await api.get("/admin/app-pages");
  return res.data;
};

export const fetchAdminAppPage = async (id) => {
  const res = await api.get(`/admin/app-pages/${id}`);
  return res.data;
};

export const createAdminAppPage = async (payload) => {
  const res = await api.post("/admin/app-pages", payload);
  return res.data;
};

export const updateAdminAppPage = async (id, payload) => {
  const res = await api.put(`/admin/app-pages/${id}`, payload);
  return res.data;
};

export const deleteAdminAppPage = async (id) => {
  const res = await api.delete(`/admin/app-pages/${id}`);
  return res.data;
};

export const resetAdminAppPages = async () => {
  const res = await api.post("/admin/app-pages/reset");
  return res.data;
};
